<div class="card mb-0">
  <div class="card-body d-flex align-items-center justify-content-center">
    <form [formGroup]="userPhoneForm">
        <!-- <div class="card-body"  style="padding: 36px 40px"> -->
          <h5 class="card-title">
            Turn On Mobile Notifications
          </h5>
          <h6>
            Enable text notifications to ensure you never miss a new review!
          </h6>
          <div>
            <ngx-intl-tel-input
              [preferredCountries]="preferredCountries"
              [enableAutoCountrySelect]="true"
              [searchCountryFlag]="true"
              [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
              [selectFirstCountry]="false" 
              [selectedCountryISO]="CountryISO.UnitedStates"
              [maxLength]="15" 
              [phoneValidation]="true" 
              [separateDialCode]="true"
              name="phoneNumber"
              formControlName="phoneNumber"
            >
            </ngx-intl-tel-input>
          </div>
          <div class="d-flex  align-items-center w-100 gap-3 mt-4">
            <label class="form-label" for="stopCampaign">
              Enable or disable Texts
            </label>

            <p-inputSwitch 
                formControlName="isEnableReviewText"
                (onChange)="handleEnableReviewTextChange($event)" 
                name="isEnableReviewText" 
                id="isEnableReviewText" 
            />
        </div>
          <p class="card-info">
            *We will never use your mobile number for solicitation purposes. Message and data rates may apply. Messaging frequency varies depending on the amount of reviews received. 
            Text HELP for help or STOP to cancel receiving messages. 
            More information can be found in <a href="https://about.plsrvw.me/terms-of-service" target="_blank">SMS Terms</a>  and <a href="https://about.plsrvw.me/privacy-policy" target="_blank">Privacy Policy</a> .
          </p>
      </form>
  </div>
</div>